import type { HTMLAttributes, ReactNode } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface QueryStateProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function LoadingState({ className, children, ...props }: QueryStateProps) {
  return (
    <div aria-live="polite" className={mergeClassNames('ds-query-state', className)} {...props}>
      {children}
    </div>
  )
}

export interface EmptyStateProps extends QueryStateProps {
  /**
   * Action de sortie de l'état vide. Deux variantes seulement, avec action ou
   * sans : un état vide n'est jamais silencieux, et quand une action permet
   * d'en sortir — créer un contrat, ajouter une adresse — elle s'affiche ici
   * plutôt que d'être laissée au jugement de chaque page.
   */
  action?: ReactNode
}

export function EmptyState({ className, children, action, ...props }: EmptyStateProps) {
  return (
    <div className={mergeClassNames('ds-query-state', className)} {...props}>
      <span>{children}</span>
      {action ? <span className="ds-query-state__action">{action}</span> : null}
    </div>
  )
}

export function ErrorState({ className, children, ...props }: QueryStateProps) {
  return (
    <div
      className={mergeClassNames('ds-query-state', 'ds-query-state--error', className)}
      role="alert"
      {...props}
    >
      {children}
    </div>
  )
}
